import { styled } from '@aether/styles'

export const Divider = styled('div', {
  width: '100%',
  height: 1,
  background: '$black',
})
